import { toast } from "react-toastify";
import { ReelsAPI } from "../constants/apiRoutes";
import { reelsActions } from "../reducers/reels";
import apiService from "../utils/configAxios";
import { handleError } from "../utils/handleError";

export const createNewReels = (data, navigate) => {
  return async (dispatch) => {
    dispatch(reelsActions.actionStart());
    try {
      await apiService.post(ReelsAPI.create(), data);
      dispatch(reelsActions.actionSuccess("create"));
    } catch (err) {
      dispatch(reelsActions.clearError());
      handleError(err);
    }
  };
};

export const updateReels = (data, navigate, id) => {
  return (dispatch) => {
    dispatch(reelsActions.actionStart());
    return apiService
      .put(ReelsAPI.update(id), data)
      .then((response) => {
        dispatch(reelsActions.actionSuccess("update"));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
export const deleteReels = (id) => {
  return (dispatch) => {
    dispatch(reelsActions.actionStart());
    return apiService
      .delete(ReelsAPI.delete(id))
      .then((response) => {
        toast.success("Uspešno ste obrisali reel", {
          theme: "colored",
        });

        dispatch(fetchReelsList());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchReelsList = () => {
  return (dispatch) => {
    return apiService
      .get(ReelsAPI.list())
      .then((response) => {
        dispatch(reelsActions.fetchReelsList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchReelsById = (id = 0) => {
  return (dispatch) => {
    return apiService
      .get(ReelsAPI.getById(id))
      .then((response) => {
        dispatch(reelsActions.fetchReelsDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchReelsStatisticList = () => {
  return (dispatch) => {
    return apiService
      .get(ReelsAPI.statistic())
      .then((response) => {
        dispatch(reelsActions.fetchReelsStatisticList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
